import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryOauthApplicationNameArgs } from 'src/types/backend';

const QUERY = gql`
  query OAuthApplicationName($clientId: String!) {
    oauthApplicationName(clientId: $clientId)
  }
`;

type Variables = BackendQueryOauthApplicationNameArgs;
type Result = string;

export const queryOAuthApplicationName = async (
  variables: Variables,
  options?: GqlQueryOptions
) => {
  const result = await executeGqlQuery({ query: QUERY, variables, options });
  return getSingleProp<Result>(result.data);
};
